var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.2338 19.8177L17.9676 14.0839H5.41607C4.81807 14.0839 4.33301 13.5988 4.33301 13.0008C4.33301 12.4028 4.81807 11.9178 5.41607 11.9178H17.9676L12.2338 6.18395C11.8104 5.76063 11.8104 5.07488 12.2338 4.65238C12.6571 4.22988 13.3428 4.22907 13.7653 4.65238L21.3484 12.2354C21.4483 12.3354 21.528 12.454 21.5832 12.5864C21.6929 12.8521 21.6929 13.1511 21.5832 13.416C21.5304 13.5436 21.4524 13.663 21.3484 13.767L13.7653 21.3501C13.342 21.7734 12.6563 21.7734 12.2338 21.3501C11.8113 20.9268 11.8104 20.241 12.2338 19.8185V19.8177Z","fill":"black"}));
}

ArrowRight.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
